<template>
    <div class="company_home">
        <!-- 导航栏组件 -->
        <navigation-bar :default-active-index="activeIndex" @menu-select="handleMenuSelect" />

        <!-- 路由视图容器 -->
        <router-view></router-view>

        <Footer></Footer>

        <!-- 数字人全局悬浮入口 -->
        <div class="dh-fab" @click="openDhConfig" title="智能数字人客服">
            <span class="iconify dh-fab-icon" data-icon="ri:robot-2-line"></span>
            <span class="dh-fab-pulse"></span>
            <div class="dh-fab-label">智能客服</div>
        </div>

        <!-- 数字人配置弹窗 -->
        <transition name="dh-fade">
            <div v-if="dhConfigVisible" class="dh-overlay" @click.self="closeDhConfig">
                <div class="dh-config-box">
                    <div class="dh-config-header">
                        <div class="dh-config-header-left">
                            <span class="iconify" data-icon="ri:robot-2-line" style="font-size:22px;color:#1976D2;"></span>
                            <span>数字人配置</span>
                        </div>
                        <button class="dh-config-close" @click="closeDhConfig">
                            <span class="iconify" data-icon="mdi:close"></span>
                        </button>
                    </div>
                    <div class="dh-config-body">
                        <div class="dh-form-group">
                            <label>客服 ID</label>
                            <input
                                v-model="dhAvatarId"
                                type="text"
                                placeholder="请输入数字人客服 ID"
                                class="dh-form-input"
                            />
                        </div>
                        <div class="dh-form-group">
                            <label>屏幕比例</label>
                            <div class="dh-ratio-options">
                                <label class="dh-ratio-option" :class="{ active: dhAspect === '16:9' }">
                                    <input type="radio" v-model="dhAspect" value="16:9" />
                                    <span>16:9 横屏</span>
                                </label>
                                <label class="dh-ratio-option" :class="{ active: dhAspect === '9:16' }">
                                    <input type="radio" v-model="dhAspect" value="9:16" />
                                    <span>9:16 竖屏</span>
                                </label>
                                <label class="dh-ratio-option" :class="{ active: dhAspect === '4:3' }">
                                    <input type="radio" v-model="dhAspect" value="4:3" />
                                    <span>4:3 标准</span>
                                </label>
                            </div>
                        </div>
                        <div v-if="dhErrorMsg" class="dh-error-tip">
                            <span class="iconify" data-icon="mdi:alert-circle-outline"></span>
                            {{ dhErrorMsg }}
                        </div>
                        <button
                            class="dh-init-btn"
                            :disabled="!dhAvatarId || dhIniting"
                            @click="initAndOpenDh"
                        >
                            <span v-if="dhIniting" class="dh-init-spin"></span>
                            {{ dhIniting ? '初始化中...' : '初始化数字人' }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 数字人弹层 -->
        <transition name="dh-fade">
            <div v-if="dhModalVisible" class="dh-overlay">
                <div class="dh-modal" :style="dhModalStyle">
                    <div class="dh-modal-header">
                        <div class="dh-modal-header-left">
                            <div class="dh-modal-avatar">
                                <span class="iconify" data-icon="ri:robot-2-line"></span>
                            </div>
                            <div>
                                <div class="dh-modal-title">智能数字人客服</div>
                                <div class="dh-modal-status">
                                    <span class="dh-status-dot"></span> 在线中
                                </div>
                            </div>
                        </div>
                        <div class="dh-modal-header-right">
                            <div v-if="false" class="dh-countdown">
                                <span class="iconify" data-icon="mdi:timer-outline"></span>
                                {{ dhCountdownDisplay }}
                            </div>
                            <button class="dh-modal-close" @click="closeDigitalHuman">
                                <span class="iconify" data-icon="mdi:close"></span>
                            </button>
                        </div>
                    </div>
                    <div class="dh-modal-body" :style="dhBodyStyle">
                        <iframe
                            v-if="dhIframeSrc"
                            ref="dhIframe"
                            :src="dhIframeSrc"
                            class="dh-iframe"
                            allow="microphone; camera; autoplay; display-capture; speaker-selection"
                            allowfullscreen
                            scrolling="no"
                            frameborder="0"
                            @load="onIframeLoad"
                        />
                        <div v-else class="dh-loading">
                            <div class="dh-loading-spin"></div>
                            <p>正在连接数字人...</p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import NavigationBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'CompanyHome',
    components: {
        NavigationBar,
        Footer
    },
    data() {
        return {
            activeIndex: '1',
            dhConfigVisible: false,
            dhModalVisible: false,
            dhIframeSrc: '',
            dhAvatarId: '',
            dhAspect: process.env.VUE_APP_NUWA_ASPECT_RATIO || '9:16',
            dhIniting: false,
            dhErrorMsg: '',
            dhCountdownSec: 0,
            _dhTimer: null,
            dhCoverVisible: false,
            dhCoverDelay: 3000,
        }
    },
    computed: {
        // 弹窗宽度：横屏给更多宽度，竖屏收窄
        dhModalStyle() {
            const [w, h] = this.dhAspect.split(':').map(Number)
            const isLandscape = w > h
            // 横屏：宽度越大窗口越大（高度 = 宽度 × h/w 自动撑开）
            // 竖屏：宽度越大高度也越高，注意别超出屏幕
            return { width: isLandscape ? 'min(960px, 92vw)' : 'min(380px, 90vw)' }
        },
        // body 按比例撑高，横屏限制不超出屏幕高度
        dhBodyStyle() {
            const [w, h] = this.dhAspect.split(':').map(Number)
            const isLandscape = w > h
            return {
                aspectRatio: `${w} / ${h}`,
                maxHeight: isLandscape ? 'calc(92vh - 66px)' : 'calc(92vh - 66px)',
            }
        },
        dhCountdownDisplay() {
            const m = Math.floor(this.dhCountdownSec / 60)
            const s = this.dhCountdownSec % 60
            return `${m}:${String(s).padStart(2, '0')}`
        },
    },
    watch: {
        '$route'(to) {
            this.updateActiveIndex(to.path)
        }
    },
    created() {
        this.updateActiveIndex(this.$route.path)
    },
    mounted() {
        this.initDigitalHuman()
    },
    beforeDestroy() {
        window.removeEventListener('message', this._onSdkMessage)
        this._stopCountdown()
    },
    methods: {
        handleMenuSelect(key) {
            this.activeIndex = key
            const routeMap = {
                '1': '/',
                '2': '/registration',
                '3': '/compliance',
                '4': '/quality',
                '5': '/valuation',
                '6': '/finance'
            }
            if (routeMap[key]) {
                this.$router.push(routeMap[key])
            }
        },

        updateActiveIndex(path) {
            const routeMap = {
                '/': '1',
                '/home': '1',
                '/registration': '2',
                '/compliance': '3',
                '/quality': '4',
                '/valuation': '5',
                '/finance': '6'
            }
            if (routeMap[path]) {
                this.activeIndex = routeMap[path]
            }
        },

        async initDigitalHuman() {
            try {
                await this.loadScript('/sdk/npcTalkFloatingButton.js')
                const apiKey = process.env.VUE_APP_NUWA_API_KEY
                const res = await fetch('https://api.nuwaai.com/web/apiKey/auth', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secretKey: apiKey })
                })
                const data = await res.json()
                if (data.code === 0) {
                    localStorage.setItem('token', data.data)
                }
            } catch (e) {
                console.error('数字人初始化失败:', e)
            }
        },

        openDhConfig() {
            this.dhErrorMsg = ''
            this.dhConfigVisible = true
        },
        closeDhConfig() {
            this.dhConfigVisible = false
        },
        async initAndOpenDh() {
            if (!this.dhAvatarId) return
            this.dhIniting = true
            try {
                // 1. 校验数字人ID
                const verifyRes = await this.$axios.get('/web/digitalHuman/verify', {
                    params: { avatarId: this.dhAvatarId }
                })
                if (!verifyRes.data || verifyRes.data.status !== 200) {
                    this.dhErrorMsg = verifyRes.data?.msg || '数字人ID无效，请确认后重试'
                    this.dhIniting = false
                    return
                }
                this.dhErrorMsg = ''

                // sliceTime 单位秒，SDK 读的是毫秒
                const sliceTime = verifyRes.data?.object?.sliceTime || 0
                localStorage.setItem('sliceTime', sliceTime > 0 ? sliceTime * 1000 : 0)

                // coverDelay 单位毫秒
                this.dhCoverDelay = verifyRes.data?.object?.coverDelay || 3000

                // 2. 加载SDK + 获取Token
                await this.loadScript('/sdk/npcTalkFloatingButton.js')
                const apiKey = process.env.VUE_APP_NUWA_API_KEY
                const res = await fetch('https://api.nuwaai.com/web/apiKey/auth', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secretKey: apiKey })
                })
                const data = await res.json()
                if (data.code === 0) {
                    localStorage.setItem('token', data.data)
                }
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                    stream.getTracks().forEach(t => t.stop())
                } catch (e) {
                    console.warn('麦克风授权失败:', e.message)
                }
                const userId = process.env.VUE_APP_NUWA_USER_ID
                localStorage.setItem('backAddress', '')
                localStorage.setItem('sdkPageTitle', '智能客服')
                localStorage.setItem('loadingConfig', encodeURIComponent(JSON.stringify({
                    html: `<div class="custom-loading-wrapper"><img src="https://cdns.esdri.cn/image/new_bg.png" style="width:100%;height:100%;object-fit:cover;position:absolute;inset:0;" /><div style="position:absolute;bottom:30px;left:50%;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:12px;"><div class="custom-loading-spinner"></div><div style="color:#fff;font-size:14px;font-family:sans-serif;">正在连接数字人...</div></div></div>`,
                    style: { position: 'relative', overflow: 'hidden' },
                    additionalCSS: `.custom-loading-container .custom-loading-wrapper{width:100%;height:100%;}.custom-loading-container .custom-loading-spinner{width:36px;height:36px;border:3px solid rgba(255,255,255,0.4);border-top-color:#fff;border-radius:50%;animation:custom-loading-spin 0.8s linear infinite;}@keyframes custom-loading-spin{to{transform:rotate(360deg);}}`
                })))
                this.dhIframeSrc = `/sdk/index-sdk.html?id=${this.dhAvatarId}&userId=${userId}`
                this.dhCoverVisible = true
                this.dhConfigVisible = false
                this.dhModalVisible = true
                window.addEventListener('message', this._onSdkMessage)
                // 启动父页面倒计时
                this._startCountdown(sliceTime)
            } catch (e) {
                this.dhErrorMsg = '初始化失败，请稍后重试'
            } finally {
                this.dhIniting = false
            }
        },

        async openDigitalHuman() {
            this.openDhConfig()
        },

        closeDigitalHuman() {
            this.dhModalVisible = false
            this.dhIframeSrc = ''
            this._stopCountdown()
            window.removeEventListener('message', this._onSdkMessage)
        },

        _startCountdown(totalSec) {
            this._stopCountdown()
            if (!totalSec || totalSec <= 0) {
                this.dhCountdownSec = 0
                return
            }
            this.dhCountdownSec = totalSec
            this._dhTimer = setInterval(() => {
                this.dhCountdownSec--
                if (this.dhCountdownSec <= 0) {
                    this.closeDigitalHuman()
                }
            }, 1000)
        },

        _stopCountdown() {
            if (this._dhTimer) {
                clearInterval(this._dhTimer)
                this._dhTimer = null
            }
            this.dhCountdownSec = 0
        },

        _onSdkMessage(e) {
            if (e.data && (e.data.type === 'back' || e.data.type === 'close' || e.data === 'back')) {
                this.closeDigitalHuman()
            }
            if (e.data && e.data.type === 'dh_ready') {
                setTimeout(() => { this.dhCoverVisible = false }, 2000)
            }
            if (e.data && e.data.type === 'dh_video_ended') {
                this.onDhVideoEnded()
            }
        },

        onDhVideoEnded() {
            const src = this.dhIframeSrc
            this.dhIframeSrc = ''
            this.$nextTick(() => {
                this.dhIframeSrc = src
                this.dhCoverVisible = true
            })
        },

        onIframeLoad() {
            try {
                const iframeWin = this.$refs.dhIframe.contentWindow
                Object.defineProperty(iframeWin.location, 'href', {
                    set: () => { this.closeDigitalHuman() },
                    configurable: true
                })
            } catch (e) {}
        },

        loadScript(src) {
            return new Promise((resolve, reject) => {
                if (document.querySelector(`script[src="${src}"]`)) { resolve(); return }
                const script = document.createElement('script')
                script.src = src
                script.onload = resolve
                script.onerror = reject
                document.head.appendChild(script)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.company_home {
    // 全局布局
}

/* 悬浮球 */
.dh-fab {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 888;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 56px;
    padding: 14px 0 10px;
    background: linear-gradient(180deg, #0D47A1 0%, #1976D2 100%);
    border-radius: 12px 0 0 12px;
    cursor: pointer;
    box-shadow: -4px 0 20px rgba(13, 71, 161, 0.35);
    transition: width 0.2s ease, box-shadow 0.2s ease;
    overflow: hidden;
}

.dh-fab:hover {
    width: 64px;
    box-shadow: -6px 0 28px rgba(13, 71, 161, 0.5);
}

.dh-fab-icon {
    font-size: 26px;
    color: #fff;
    position: relative;
    z-index: 1;
}

.dh-fab-pulse {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.35);
    animation: fab-pulse 2.5s ease-out infinite;
}

@keyframes fab-pulse {
    0%   { transform: translateX(-50%) scale(0.9); opacity: 0.7; }
    100% { transform: translateX(-50%) scale(1.6); opacity: 0; }
}

.dh-fab-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 600;
    letter-spacing: 0.5px;
    writing-mode: vertical-rl;
    text-orientation: mixed;
}

/* 全屏遮罩 */
.dh-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 弹窗 */
.dh-modal {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
    max-height: 92vh;
    /* 宽度由 dhModalStyle 动态注入，此处为 JS 未加载时的兜底 */
    width: min(340px, 90vw);
}

.dh-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    background: linear-gradient(135deg, #0D47A1, #1976D2);
    flex-shrink: 0;
}

.dh-modal-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dh-countdown {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 20px;
    padding: 3px 10px;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.5px;
}

.dh-countdown .iconify { font-size: 14px; }

.dh-modal-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.dh-modal-avatar {
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #fff;
    flex-shrink: 0;
}

.dh-modal-title {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    line-height: 1.3;
}

.dh-modal-status {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 2px;
}

.dh-status-dot {
    width: 7px;
    height: 7px;
    background: #52c41a;
    border-radius: 50%;
    display: inline-block;
    box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.3);
    animation: dot-pulse 2s ease-out infinite;
}

@keyframes dot-pulse {
    0%   { box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4); }
    100% { box-shadow: 0 0 0 6px rgba(82, 196, 26, 0); }
}

.dh-modal-close {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    font-size: 18px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.dh-modal-close:hover {
    background: rgba(255, 255, 255, 0.3);
}

/* iframe 9:16 容器 */
.dh-modal-body {
    position: relative;
    /* aspect-ratio 和 max-height 由 dhBodyStyle 动态注入 */
    overflow: hidden;
    background: #000;
    width: 100%;
    flex-shrink: 0;
}

.dh-iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
    display: block;
}

.dh-loading {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    color: #909399;
    font-size: 14px;
    background: #f5f7fa;
}

.dh-loading-spin {
    width: 40px;
    height: 40px;
    border: 3px solid #e4e7ed;
    border-top-color: #409EFF;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* 封面遮罩 */
.dh-cover {
    position: absolute;
    inset: 0;
    z-index: 10;
    overflow: hidden;
}

.dh-cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
}

.dh-cover-spin {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    height: 32px;
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.dh-cover-fade-leave-active {
    transition: opacity 0.6s ease;
}
.dh-cover-fade-leave-to {
    opacity: 0;
}

/* 配置弹窗 */
.dh-config-box {
    background: #fff;
    border-radius: 16px;
    width: min(440px, 92vw);
    box-shadow: 0 20px 60px rgba(0,0,0,0.25);
    overflow: hidden;
}

.dh-config-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e5e7eb;
}

.dh-config-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 700;
    color: #1f2937;
}

.dh-config-close {
    background: none;
    border: none;
    font-size: 20px;
    color: #9ca3af;
    cursor: pointer;
    line-height: 1;
    padding: 2px;
    transition: color 0.2s;
}

.dh-config-close:hover { color: #374151; }

.dh-config-body {
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.dh-form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dh-form-group label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
}

.dh-form-input {
    width: 100%;
    padding: 10px 14px;
    border: 1.5px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;
}

.dh-form-input:focus { border-color: #1976D2; }

.dh-ratio-options {
    display: flex;
    gap: 10px;
}

.dh-ratio-option {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    border: 1.5px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s;
}

.dh-ratio-option.active {
    border-color: #1976D2;
    background: #e3f2fd;
    color: #0D47A1;
    font-weight: 600;
}

.dh-ratio-option input { cursor: pointer; }

.dh-init-btn {
    width: 100%;
    padding: 12px;
    background: linear-gradient(135deg, #0D47A1, #1976D2);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s, transform 0.2s;
}

.dh-init-btn:hover:not(:disabled) { transform: translateY(-1px); opacity: 0.92; }
.dh-init-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.dh-error-tip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    background: #fff2f0;
    border: 1px solid #ffccc7;
    border-radius: 8px;
    color: #cf1322;
    font-size: 13px;
}

.dh-error-tip .iconify { font-size: 16px; flex-shrink: 0; }

.dh-init-spin {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255,255,255,0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    flex-shrink: 0;
}

/* 弹层动画 */
.dh-fade-enter-active,
.dh-fade-leave-active {
    transition: opacity 0.25s ease;
}
.dh-fade-enter,
.dh-fade-leave-to {
    opacity: 0;
}
.dh-fade-enter .dh-modal,
.dh-fade-leave-to .dh-modal {
    transform: scale(0.92);
}

.dh-video-modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 10000;
    background: rgba(0,0,0,0.85);
    display: flex;
    align-items: center;
    justify-content: center;
}

.dh-video-modal {
    position: relative;
    width: min(960px, 92vw);
    aspect-ratio: 16/9;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 24px 80px rgba(0,0,0,0.6);
}

.dh-video-el {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

.dh-video-close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    width: 32px;
    height: 32px;
    background: rgba(0,0,0,0.5);
    border: none;
    border-radius: 50%;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dh-video-close:hover { background: rgba(0,0,0,0.8); }
</style>
